import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LazyMotion } from 'framer-motion';

const loadFeatures = () => import('./utils/motion-features.js').then((res) => res.default);
import DashboardRouter from './router/index.jsx';
import { withAuthentication } from 'components/Session/index.js';
import Layout from './Layout.jsx';
import LayoutContextProviders from './LayoutContextProviders.jsx';

class App extends Component {
  render() {
    return (
      <LazyMotion features={loadFeatures} strict>
        <Router>
          <LayoutContextProviders>
            <Layout>
              <DashboardRouter />
            </Layout>
          </LayoutContextProviders>
        </Router>
      </LazyMotion>
    );
  }
}

export default withAuthentication(App);
